<template>
  <div>
    <div class="nav-bar" :class="{ sticky: isSticky }">
      <div class="nav-left">
        <div @click="handlogo" style="cursor: pointer;">
          <img src="../../assets/images/logo.svg" alt=""/>
        </div>
      </div>
      <div class="nav-rignt">
        <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            style="display: flex"
            router>
          <div v-for="item in navData" :key="item.id">
            <el-menu-item v-if="!item.children" :index="item.code" @click="clickChild(item)">
              {{ item.name }}
            </el-menu-item>
            <el-submenu v-else :index="item.code" :key="item.id" @click="clickChild(v)">
              <template slot="title">{{ item.name }}</template>
              <el-menu-item v-for="v in item.children" :index="v.code" :key="v.id" @click="clickChild(v)">
                {{ v.name }}
              </el-menu-item>
            </el-submenu>
          </div>
        </el-menu>
      </div>
    </div>
    <div class="nav-wap">
      <div @click="handlogo" style="cursor: pointer;">
        <img style="width: 80px" src="../../assets/images/logo.svg" alt=""/>
      </div>
      <div class="navicon" @click="handleClose()">
        <i class="el-icon-menu" style="font-size: 20px"></i>
      </div>
    </div>
    <el-drawer
        size="50%"
        :append-to-body="true"
        :before-close="handleClose"
        :visible.sync="innerDrawer">
      <div class="navList" v-for="(item,index) in navData" :key="index" @click="clickChild(item)">
        <div :class="{'actived':selected==item?.id}">{{ item.name }}</div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import router from "@/router";
import {newsTree} from "@/api/news";

export default {
  name: `navbar`,
  data() {
    return {
      navData: [],
      innerDrawer: false,
      selected: 0,
      isSticky: false,
    }
  },
  created() {
    this.getnavData()
  },
  onMounted() {
    this.activeIndex = router.currentRoute;
    console.log('router.currentRoute', router)
  },
  mounted() {
    // this.activeIndex = router.currentRoute;
    console.log('router.currentRoute', router)
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    activeIndex() {
      const route = this.$route
      const {query, path} = route
      if (query.id) {
        return query.id
      }
      return path
    }
  },

  methods: {
    handleScroll() {
      this.isSticky = window.scrollY > 0; // 根据页面的滚动位置来设置isSticky
    },
    handleClose() {
      this.innerDrawer = !this.innerDrawer
    },
    //获取导航菜单
    getnavData() {
      newsTree().then(res => {
        const nav = res.data
        this.navData = this.getNewTree(nav)
        this.selected = this.navData[0].id
        this.navData.forEach(item => {
          item.path = item.code + '/' + item.id
          if (item.children.length === 0) {
            delete item.children
          } else {
            item.children.forEach(items => {
              items.path = item.code + '/' + item.id
            })
          }
        })
      })
    },
    //删除多余的children
    getNewTree(obj) {
      obj.map(item => {
        if (item.id) {
          item.id = String(item.id)
        }
        if (item.children && item.children.length > 0) {
          this.getNewTree(item.children)
        }
      })
      return obj
    },
    // 路由
    router() {
      return router
    },
    //点击路由跳转
    clickChild(item) {
      // console.log('item',item)
      this.selected = item.id
      this.$router.push({
        path: item.code,
        query: {
          id: item.id,
        }
      })
      this.innerDrawer = false
    },
    //点击logo事件
    handlogo() {
      this.$router.push({name: 'index'})
    }
  }
};
</script>
<style lang="scss" scoped>
.sticky {
  background: #fff;
  border-bottom: 1px solid #f9f9f9;
}

.actived {
  color: #0f50d3;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.nav-bar {
  justify-content: space-between;
  list-style-type: none;
  //width: calc(100% - 32px);
  align-items: center;
  margin: 0 auto;
  display: flex;
  height: 64px;
  padding: 0 44px;

  .nav-left {
    display: flex;

    .logo {
      width: 86px;
      opacity: .8;
      display: flex;
      align-items: center;
      height: 64px;
      margin-right: 32px;
    }
  }

  .nav-rignt {
    .el-menu.el-menu--horizontal {
      border-bottom: none !important;
    }

    list-style: none;
    display: flex;
    align-items: center;


    li {
      //padding: 0 12px;
      /deep/ .el-submenu__icon-arrow {
        right: 5px
      }

      .el-button {
        background: #05cd78;
      }
    }
  }
}

</style>
